var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2593 15.1154C13.7719 15.6279 14.603 15.6279 15.1155 15.1154C15.6279 14.6028 15.6279 13.7717 15.1155 13.2591L9.85643 8.00003L15.1154 2.74097C15.6279 2.22841 15.6279 1.39739 15.1154 0.884815C14.603 0.372257 13.7719 0.372257 13.2593 0.884815L8.00021 6.14399L2.74109 0.884797C2.22852 0.372222 1.39749 0.372222 0.884937 0.884797C0.372362 1.39735 0.372362 2.22838 0.884937 2.74095L6.14398 8.00003L0.88492 13.2591C0.372345 13.7717 0.372345 14.6028 0.88492 15.1154C1.39748 15.6279 2.2285 15.6279 2.74107 15.1154L8.00021 9.85626L13.2593 15.1154Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCrossIcon);
export default __webpack_public_path__ + "static/media/AlertCrossIcon.0f3ff653d377d6c62d259136ea35aad7.svg";
export { ForwardRef as ReactComponent };